import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import SingleAvatar from './SingleAvatar';
import MultiAvatar from './MultiAvatar';
const Avatar = /*#__PURE__*/memo(_ref => {
  let {
    sources,
    ...props
  } = _ref;
  const Component = sources ? MultiAvatar : SingleAvatar;
  const finalProps = useMemo(() => sources ? {
    sources,
    ...props
  } : {
    ...props
  }, [props, sources]);
  return /*#__PURE__*/React.createElement(Component, finalProps);
});
Avatar.defaultProps = {
  type: 'round',
  size: 'medium'
};
process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    placeholder: PropTypes.string,
    alt: PropTypes.string
  })),
  src: PropTypes.string,
  placeholder: PropTypes.string,
  alt: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['round', 'square']),
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'big', 'huge'])
} : void 0;
export default Avatar;